import { render, staticRenderFns } from "./VocabularyDelete.vue?vue&type=template&id=103da7b0&scoped=true&"
import script from "./VocabularyDelete.vue?vue&type=script&lang=js&"
export * from "./VocabularyDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "103da7b0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
